import { cn as a } from "../../utils/utils.js";
import { Input as u } from "./input.js";
import { Label as x } from "./label.js";
import { jsx as o, jsxs as c } from "react/jsx-runtime";
import { cva as n } from "class-variance-authority";
var h = n("absolute top-5.5 z-2 origin-[0] -translate-y-4 scale-100 transform truncate text-[16px] duration-300 peer-placeholder-shown:top-4.5 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-placeholder-shown:text-[14px] peer-autofill:top-5.5 peer-autofill:-translate-y-4 peer-autofill:scale-100 peer-autofill:text-[14px] peer-focus:top-5.5 peer-focus:-translate-y-4 peer-focus:text-[14px] peer-[:not(:placeholder-shown)]:text-[14px] sm:peer-placeholder-shown:text-[16px] sm:peer-autofill:text-[14px] sm:peer-focus:text-[14px]", {
  variants: {
    variant: {
      default: "text-secondary-700 peer-focus:text-primary-700",
      highlight: "text-info-700 peer-focus:text-info-700",
      invalid: "text-error-700 peer-focus:text-error-700",
      disabled: "peer-disabled:text-secondary-500"
    },
    iconPosition: {
      default: "start-4",
      start: "start-2"
    }
  },
  defaultVariants: { variant: "default" }
}), b = n("relative box-border flex h-14 w-full flex-row items-center justify-start rounded-sm border-1 p-0 text-base peer-focus-visible:border-red-800", {
  variants: { variant: {
    default: "border-secondary-700 bg-white text-gray-900 focus-within:border-primary-800",
    highlight: "border-secondary-700 bg-white text-gray-900",
    invalid: "border-error-400 bg-error-100 text-error-700",
    disabled: "border-secondary-400 bg-secondary-100 text-secondary-600"
  } },
  defaultVariants: { variant: "default" }
}), f = n("flex items-center justify-center ps-4 [&_*]:stroke-[1.5] [&_svg]:h-6 [&_svg]:min-h-6 [&_svg]:w-6 [&_svg]:min-w-6", {
  variants: { variant: {
    default: "[&_*]:stroke-primary-800",
    highlight: "[&_*]:stroke-info-600",
    invalid: "[&_*]:stroke-error-400",
    disabled: "[&_*]:stroke-secondary-400"
  } },
  defaultVariants: { variant: "default" }
}), _ = ({ className: s, ref: l, variant: t, startIcon: e, endIcon: r, interactiveIcon: d, children: p, ...i }) => /* @__PURE__ */ c("div", {
  className: b({ variant: t }),
  children: [
    e && /* @__PURE__ */ o("span", {
      role: d ? void 0 : "presentation",
      className: a(f({ variant: t }), "ps-4"),
      children: e
    }),
    /* @__PURE__ */ c("div", {
      className: a("relative flex h-full w-full flex-row items-center justify-start gap-0 overflow-hidden rounded-sm bg-transparent"),
      children: [/* @__PURE__ */ o(u, {
        className: a("peer z-2 box-border h-full w-full appearance-none rounded-sm border-0 bg-transparent px-4 pt-6 pb-2 text-base selection:bg-[#b3d4fc] selection:text-secondary-900 placeholder:text-body-2 placeholder:text-secondary-900 focus-visible:ring-0 focus-visible:outline-none disabled:text-secondary-600", {
          "ps-4": !e,
          "pe-4": !r,
          "ps-2": e,
          "pe-2": r,
          "pt-2": !p
        }, s),
        ref: l,
        ...i,
        placeholder: i.placeholder == null ? " " : i.placeholder
      }), p]
    }),
    r && /* @__PURE__ */ o("span", {
      role: d ? void 0 : "presentation",
      className: a(f({ variant: t }), "pe-4"),
      children: r
    })
  ]
}), N = ({ className: s, ref: l, variant: t, iconPosition: e, ...r }) => /* @__PURE__ */ o(x, {
  className: a(h({
    variant: t,
    iconPosition: e
  }), s),
  ref: l,
  ...r
});
export {
  _ as FloatingInput,
  N as FloatingLabel
};

//# sourceMappingURL=floating-input.js.map